import { Injectable } from '@angular/core';
import { Observable, shareReplay, switchMap } from 'rxjs';
import { SportFacilityZone } from '@models';
import { where } from '@angular/fire/firestore';
import { FirestoreService } from './firestore.service';
import { TenantContextService } from './tenant-context.service';

@Injectable({
  providedIn: 'root',
})
export class FacilityZoneService {
  public all$: Observable<SportFacilityZone[]>;

  constructor(
    private readonly firestore: FirestoreService,
    private readonly tenantContext: TenantContextService,
  ) {
    this.all$ = this.tenantContext.tenantId$.pipe(
      switchMap(() =>
        this.firestore.listDocuments<SportFacilityZone>(
          this.tenantContext.collections.FACILITY_ZONES,
        ),
      ),
      shareReplay(1),
    );
  }

  getActive$(): Observable<SportFacilityZone[]> {
    return this.tenantContext.tenantId$.pipe(
      switchMap(() =>
        this.firestore.listDocuments<SportFacilityZone>(
          this.tenantContext.collections.FACILITY_ZONES,
          where('active', '==', true),
        ),
      ),
      shareReplay(1),
    );
  }

  async create(data: Omit<SportFacilityZone, 'id'>): Promise<string> {
    return this.firestore.create<SportFacilityZone>(
      this.tenantContext.collections.FACILITY_ZONES,
      data,
    );
  }

  async update(
    data: Partial<SportFacilityZone> & { id: string },
  ): Promise<void> {
    return this.firestore.update<SportFacilityZone>(
      this.tenantContext.collections.FACILITY_ZONES,
      data,
    );
  }

  async delete(id: string): Promise<void> {
    return this.firestore.delete(
      this.tenantContext.collections.FACILITY_ZONES,
      id,
    );
  }
}
